import {FC, useEffect} from 'react';
//formik
import {Field, useFormikContext} from 'formik';
import {AddTableTicketFormValues} from '../../formConfiguration';
//mui
import {Box, FormControl, RadioGroup, Typography} from '@mui/material';
//constants
import {BANK_TRANSFER, CHOSE_PAYMENT_OPTION, FIELD, PAY_WITH_CREDIT_CARD, PRIMARY, SUBTITLE1} from '@/utils/constants';
//components
import Radio from '@/shared/components/Radio';
//enums
import {PAYMENT_METHOD} from '@/utils/enums';
//icons
import {ReactComponent as CardIcon} from '@/assets/icons/card.svg';
import {ReactComponent as BankIcon} from '@/assets/icons/bank.svg';
//styles
import {paymentOptionsStyles} from './PaymentOptions.styles';

const PaymentOptions: FC = () => {
	const {
		values: {paymentOption},
		setFieldValue,
	} = useFormikContext<AddTableTicketFormValues>();

	useEffect(() => {
		if (paymentOption === PAYMENT_METHOD.INVOICE) {
			setFieldValue('isCoverFee', false);
		} else {
			setFieldValue('isCoverFee', true);
		}
	}, [paymentOption]);

	return (
		<Box>
			<Typography variant={SUBTITLE1} sx={paymentOptionsStyles.title}>
				{CHOSE_PAYMENT_OPTION}
			</Typography>

			<FormControl>
				<RadioGroup defaultValue={PAYMENT_METHOD.CREDIT_CARD}>
					<Box sx={paymentOptionsStyles.content}>
						<Box
							sx={{
								...paymentOptionsStyles.radio,
								...(paymentOption === PAYMENT_METHOD.CREDIT_CARD && paymentOptionsStyles.activeRadio),
							}}
						>
							<Field
								id={FIELD.paymentOption}
								name={FIELD.paymentOption}
								color={PRIMARY}
								value={PAYMENT_METHOD.CREDIT_CARD}
								component={Radio}
								label={
									<Box sx={paymentOptionsStyles.radioLabel}>
										<CardIcon />
										<Typography variant={SUBTITLE1} sx={paymentOptionsStyles.radioTitle}>
											{PAY_WITH_CREDIT_CARD}
										</Typography>
									</Box>
								}
							/>
						</Box>

						<Box
							sx={{
								...paymentOptionsStyles.radio,
								...(paymentOption === PAYMENT_METHOD.BANK_TRANSFER && paymentOptionsStyles.activeRadio),
							}}
						>
							<Field
								id={FIELD.paymentOption}
								name={FIELD.paymentOption}
								color={PRIMARY}
								value={PAYMENT_METHOD.BANK_TRANSFER}
								component={Radio}
								label={
									<Box sx={paymentOptionsStyles.radioLabel}>
										<BankIcon />
										<Typography variant={SUBTITLE1} sx={paymentOptionsStyles.radioTitle}>
											{BANK_TRANSFER}
										</Typography>
									</Box>
								}
							/>
						</Box>
					</Box>
				</RadioGroup>
			</FormControl>
		</Box>
	);
};

export default PaymentOptions;
